// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__37xRM","title":"Info_title__2Jkl7","links":"Info_links__2ZBr_","link":"Info_link__1mJss","logo":"Info_logo__39o-g"};